import React from 'react';
import Login from "./components/Login";
import Register from "./components/Register";
import HeroLandingPage from "./components/HeroLandingPage";
import Schedule from "./components/Schedule";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import BarberLogin from "./components/BarberLogin";
import BarberDashboard from "./components/barberDashboard/BarberDashboard";
import Success from "./components/Success";
import Cancel from "./components/Cancel";
import Appointments from "./components/Appointments";
import Navbar from "./components/Navbar";
import useAuth from './hooks/useAuth';  // Import the custom hook
import PersistLogin from './components/PersistLogin';
import BarberCreateAppointment from './components/barberDashboard/BarberCreateAppointment';
import UserProfile from './components/UserProfile';
import BarberHome from './components/barberDashboard/BarberHome';
import BarberBreaks from './components/barberDashboard/newDashBoardPages/BarberBreaks';
import BarberAppointments from './components/barberDashboard/newDashBoardPages/BarberAppointments';
import BarberWorkSettings from './components/barberDashboard/newDashBoardPages/BarberWorkSettings';

function App() {
  const { auth } = useAuth();
  const isAuthenticated = !!auth?.token; // True if accessToken exists, false otherwise

  return (
    
    <Router>
      <Navbar isAuthenticated={isAuthenticated} />
      <Routes>
        <Route path="/" element={<HeroLandingPage />} />
        <Route path="/login" element={<Login isAuthenticated={isAuthenticated}/>} />
        <Route path="/register" element={<Register isAuthenticated={isAuthenticated}/>} />
        <Route path="/barber-login" element={<BarberLogin />} />
        <Route element={<PersistLogin/>}> 
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/barber-dashboard" element={<BarberHome />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/success" element={<Success />} />
          <Route path="/appointments" element={<Appointments />} />
          <Route path="/barber-create-appointment" element={<BarberCreateAppointment />}/>
          <Route path="/user-profile" element={<UserProfile />} />
          <Route path="/barber-breaks" element={<BarberBreaks />} />
          <Route path="/barber-appointments" element={<BarberAppointments />} />
          <Route path="/barber-settings" element={<BarberWorkSettings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
